import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FloorListHeaderInner, FloorListHeaderWrapper } from "./Floor.style";
const FileRowHeader = () => {
    return (_jsxs(FloorListHeaderWrapper, { children: [_jsx("div", {}), _jsxs(FloorListHeaderInner, { children: [_jsx("div", { children: "File" }), _jsx("div", { children: "Elevation (Sort)" }), _jsx("div", { children: "Label" }), _jsx("div", { children: "Default" })] }), _jsx("div", {})] }));
};
export default FileRowHeader;
